export default "__VITE_ASSET__DdaDNDkO__"